import PatientWorkEdit from './edit.vue'
import PatientWorkList from './list.vue'
import PatientWorkInfo from './info.vue'
import PatientEdit from './editPatient.vue'




import * as OrderCompleted from './completed'
import * as OrderProcess from './processing'


let a = Object.assign({ PatientWorkEdit, PatientWorkList,PatientWorkInfo,PatientEdit },OrderCompleted, OrderProcess,)
export default a
